import {
  ACTIVO_TIPOS_USUARIOS,
  CLEAR_ALL,
  GETALL_TIPOS_USUARIOS,
  LOADING_GETALL_TIPOS_USUARIOS,
  PARAMS_TIPOS_USUARIOS,
  SET_LOGOUT,
} from '../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  activo: null,
  params: {},
};

export const tiposUsuariosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_TIPOS_USUARIOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_TIPOS_USUARIOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_TIPOS_USUARIOS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_TIPOS_USUARIOS:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
